export default "__VITE_ASSET__B79uyrVu__"